import script from "./ManageNotesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageNotesView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageNotesView.vue?vue&type=style&index=0&id=16ea6b3c&lang=scss"

const __exports__ = script;

export default __exports__